export default {
  list: [
    {
      value: 'POUND',
      title: 'پوند'
    },
    {
      value: 'DOLLAR',
      title: 'دلار'
    },
    {
      value: 'RIAL',
      title: 'ریال'
    },
    {
      value: 'TOMAN',
      title: 'تومان'
    }
  ],
  values: {
    TOMAN: 'TOMAN',
    DOLLAR: 'DOLLAR',
    RIAL: 'RIAL',
    POUND: 'POUND'
  }
};
